// Helper function to handle variant changes for Kaching cart
(() => {
  const cache = new Map();

  const getHandle = (item) => {
    const el = item.querySelector('.kaching-product-upsell-item');
    if (el?.dataset.productHandle) return el.dataset.productHandle;
    const href = item.querySelector('.kaching-product-upsell-item__title[href*="/products/"]')?.href;
    return href?.split('/products/')[1]?.split('?')[0] || null;
  };

  const getProduct = async (handle) => {
    if (!handle) return null;
    if (!cache.has(handle)) {
      cache.set(handle, fetch(`/products/${handle}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null));
    }
    return cache.get(handle);
  };

  async function syncItem(item) {
    const selects = [...item.querySelectorAll('.kaching-cart-selector')];
    const product = await getProduct(getHandle(item));
    if (!selects.length || !product?.variants?.length) return;

    const selected = selects.map((s) => s.value);
    selects.forEach((select, i) => {
      [...select.options].forEach((option) => {
        const values = [...selected];
        values[i] = option.value;
        const variant = product.variants.find((v) => values.every((value, idx) => !value || v.options?.[idx] === value));
        if (variant?.id) option.dataset.variantId = String(variant.id);
      });
    });
  }

  const initAll = () => document.querySelectorAll('.kaching-cart__carousel-item').forEach(syncItem);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('change', (event) => {
    const select = event.target?.closest?.('.kaching-cart-selector');
    if (!select) return;
    const item = select.closest('.kaching-cart__carousel-item');
    if (!item) return;
    syncItem(item);
    if (window.Abra?.render) setTimeout(() => window.Abra.render(), 500);
  });
})();

// New custom event for stack collection to trigger when variant changes
(() => {
  document.addEventListener('click', (event) => {
    const btn = event.target?.closest?.('.stack_option-btn');
    if (!btn) return;

    const card = btn.closest('.stack_product-card');
    const priceWrap = card?.querySelector('.stack_card-price');

    window.dispatchEvent(
      new CustomEvent('stack:variant:changed', {
        detail: {
          productHandle: card?.getAttribute('data-product-handle') || priceWrap?.getAttribute('data-product-handle') || null,
          variantId: priceWrap?.getAttribute('data-variant-id') || null,
          optionValue: btn.getAttribute('data-option-value') || null
        }
      })
    );
  });
})();